import { Branding } from 'packages/theming/brands';

export const branding: Branding = {
  siteName: 'Stir',
  favIconName: 'favicon-stir',
  name: 'stir',
  instagramUrl: 'https://www.instagram.com/stir.app',
  securityEmail: 'security@stir.com',
};

export default branding;
